const UPDATE = "UPDATE";

const initialState = {
    options:{
        date: "",
        deadline: "",
        message: "",
        name: "",
        target_location: "",
        type: ""
    },
    positions:[],
};

/**
 * Start Callbacks
 **/

function updateState(state, data) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    stateCopy.options = data.options;
    stateCopy.positions = data.positions;
    return stateCopy;
}

/**
 * End of Callbacks
 **/

const reportReducer = (state = initialState, action) => {

    if(action.type === UPDATE){
        return updateState(state, action.data);
    } else {
        return state;
    }

};

/**
 * ACTIONS
 */

export function setState(data) {
    return {type: UPDATE, data};
}

export default reportReducer;